<template>
<div class="row clearfix">
  <div v-if="loading">
    <BlockUI :message="blockuimsg"></BlockUI>
  </div>
  <div class="card">
    <div class="body">
    <div class="col-lg-12">
      <exercises ref="exercise_child" :exercise="exercise" :engine="engine"></exercises>
      <br>
      <ValidationObserver ref="formValidation">
      <div class="col-sm-12 p-0 m-0">
        <div>
          <div class="mb-2 font-weight-bold">Estrategia</div>
          <select class="form-control" v-model="configuration.ESTRATEGIAS_ID"
            @change="onStrategy($event.target.value)">
            <option v-for="(es, i) of strategies" :key="i" :value="es.ID">
                {{ es.NOMBRE }}
            </option>
          </select>
        </div>
      </div>
      <br/>
      <div class="row">
        <b-col class="col-md-4">
          <div class="mb-2 font-weight-bold">Representaciones</div>
          <div class="custom-control custom-checkbox">
            <input type="checkbox" class="custom-control-input"
              id="verbaloral" v-model="configuration.VERBAL_ORAL">
            <label class="custom-control-label" for="verbaloral">
            Verbal oral</label>
          </div>
          <div class="custom-control custom-checkbox">
            <input type="checkbox" class="custom-control-input"
            v-model="configuration.VERBAL_ESCRITO"
            id="verbalescrito">
            <label class="custom-control-label" for="verbalescrito">
            Verbal escrito</label>
          </div>
          <br/>
          <div class="custom-control custom-checkbox">
            <input type="checkbox" class="custom-control-input"
            v-model="configuration.RESP_VERBAL_ORAL"
            id="resverbaloral">
            <label class="custom-control-label" for="resverbaloral">
            Respuesta verbal oral</label>
          </div>
          <div class="custom-control custom-checkbox">
            <input type="checkbox" class="custom-control-input"
            v-model="configuration.RESP_VERBAL_ESCRITO"
            id="resverbalescrito">
            <label class="custom-control-label" for="resverbalescrito">
            Respuesta verbal escrito</label>
          </div>
          <br/>
          <div class="custom-control custom-checkbox mb-2">
            <input type="checkbox" class="custom-control-input"
            v-model="configuration.SIMPLIFICAR_RESULTADO"
            id="simpres">
            <label class="custom-control-label" for="simpres">
            Simplificar resultado</label>
          </div>
        </b-col>
        <b-col class="col-md-4">
          <div class="mb-2 font-weight-bold">Configuración</div>
          Aproximar<select class="form-control" v-model="configuration.APROXIMAR">
              <option value="0">Sin aproximación</option>
              <option value="1">Aproximación resultado</option>
              <option value="3">Aproximación operandos</option>
            </select>
          <div v-if="parseInt(configuration.APROXIMAR) !== 0">
            <br/>
            Nivel de aproximación
            <select class="form-control" v-model="configuration.NIVEL_APROXIMAR">
              <option value="-5">Cienmilésimas</option>
              <option value="-4">Diezmilésimas</option>
              <option value="-3">Milésimas</option>
              <option value="-2">Centésimas</option>
              <option value="-1">Décimas</option>
              <option value="0">Unidad</option>
              <option value="1">Decena</option>
              <option value="2">Centena</option>
              <option value="3">U.millar</option>
              <option value="4">D.millar</option>
              <option value="5">C.millar</option>
              <option value="6">U.millón</option>
              <option value="7">D.millón</option>
              <option value="8">C.millón</option>
            </select>
          </div>
          <br/>
          Máximos decimales
          <b-form-input type="number"
            v-model="configuration.MAX_DECIMALES">
            </b-form-input>
        </b-col>
        <b-col class="col-md-4 mt-2">
          <br/>
          Potencia resultado<select class="form-control" v-model="configuration.POTENCIA_RESULTADO">
              <option value="0">Potencia</option>
              <option value="1">Número natural</option>
            </select>
          <br/>
          Potencia ecuación<select class="form-control" v-model="configuration.POTENCIA_ECUACION">
              <option value="0">Potencia</option>
              <option value="1">Número natural</option>
            </select>
          <br/>
          Redondear<select class="form-control" v-model="configuration.REDONDEAR">
              <option value="0">Truncar</option>
              <option value="1">Redondear</option>
            </select>
        </b-col>
      </div>
      <br/>
      <hr>
      <b-row>
        <b-col style="text-align:center">
          <div class="d-inline">
            <a href="https://www.hostmath.com/" target="_blank"><i class="zmdi zmdi-link" /> Editor de Latex</a>
            <b-button @click="bShowLatex = !bShowLatex" class="btn btn-warning ml-2 p-1" size="sm">Ver latex</b-button>
            <span class="mx-3">|</span>
          </div>
          <strong>Operaciones del ejercicio</strong>
          <b-button v-if="arrayEleOperation.length > 1" @click="removeArrayEleOperation()" class="btn btn-danger ml-2" size="sm">-</b-button>
          <b-button @click="addArrayEleOperation()" class="btn btn-primary ml-2" size="sm">+</b-button>
        </b-col>
      </b-row>
      <br>
      <b-row class="justify-content-center">
          <b-col md="7" style="text-align:center"><h6>Operación</h6></b-col>
          <b-col md="3" style="text-align:center" v-if="bShowLatex"><h6>Visualización</h6></b-col>
          <b-col md="2" style="text-align:center"><h6>Resultado</h6></b-col>
      </b-row>
      <div>
        <div v-for="(operation, index) in arrayEleOperation" v-bind:key="index">
            <b-row style="margin-bottom: 10px" class="justify-content-center">
              <b-col md="7">
                <ValidationProvider rules="required" v-slot="{ errors }">
                  <b-form-input @change="checkOperationSymbols(index)"
                    v-bind:id="'OPERACION' + index"
                    v-model="arrayEleOperation[index].OPERACION" />
                  <span class="validation-error">{{ errors[0] }}</span>
                </ValidationProvider>
              </b-col>
              <b-col md="3" style="text-align:center" v-if="bShowLatex">
                <div v-katex="arrayEleOperation[index].OPERACION"></div>
              </b-col>
              <b-col md="2">
                <ValidationProvider rules="required" v-slot="{ errors }">
                  <b-form-input
                    v-bind:id="'RESULTADO' + index"
                    v-model="arrayEleOperation[index].RESULTADO" />
                  <span class="validation-error">{{ errors[0] }}</span>
                </ValidationProvider>
              </b-col>
          </b-row>
        </div>
      </div>
      <br>
      <b-row>
        <b-col class="text-center">
          <button v-on:click="saveStorage" :disabled="arrayEleOperation.length < 1" class="btn btn-info btn-lg">
            Guardar
          </button>
        </b-col>
      </b-row>
      </ValidationObserver>
    </div>
    </div>
  </div>
</div>
</template>

<script>
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import exercises from '../../exercises/exercise.vue';
import engineMixin from '../../../../mixins/engine';

extend('required', {
  ...required,
  message: 'Campo obligatorio.',
});

export default {
  components: {
    exercises,
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    engine: Number,
    exercise: Object,
    type: String,
  },
  mixins: [engineMixin],
  data() {
    return {
      bShowLatex: false,
      arrayEleOperation: [],
      strategies: [],
      // Datos de OPERACIONES_CONF
      configuration: {
        ID: -1,
        VERBAL_ORAL: false,
        VERBAL_ESCRITO: false,
        RESP_VERBAL_ORAL: false,
        RESP_VERBAL_ESCRITO: false,
        SIMPLIFICAR_RESULTADO: true,
        MAX_DECIMALES: 2,
        REDONDEAR: 1,
        APROXIMAR: 0,
        NIVEL_APROXIMAR: 3,
        POTENCIA_RESULTADO: 0,
        POTENCIA_ECUACION: 0,
        ESTRATEGIAS_ID: 0,
        EJERCICIOS_ID: -1,
      },
    };
  },
  methods: {
    checkOperationSymbols(index) {
      let newStr = this.arrayEleOperation[index].OPERACION.replace(/x/gi, '*');
      newStr = newStr.replace(/·/gi, '*');
      newStr = newStr.replace(/,/gi, '.');
      this.arrayEleOperation[index].OPERACION = newStr;
    },
    removeArrayEleOperation() {
      this.arrayEleOperation.pop();
    },
    addArrayEleOperation() {
      this.arrayEleOperation.push({
        POSICION: this.arrayEleOperation.length + 1,
        OPERACION: null,
        RESULTADO: null,
      });
    },
    /**
    * @method getStrategies
    * @description Obtiene las estrategies
    */
    async getStrategies() {
      this.loading = true;

      console.log(this.strategies);
      try {
        const response = await this.axios.get('strategies');
        this.strategies = response.data;
      } catch (e) {
        // nothing
      }

      this.loading = false;
    },
    /**
    * @method onStrategy
    * @description Al seleccionar la estrategia
    */
    onStrategy(value) {
      this.configuration.ESTRATEGIAS_ID = value;
    },
    /**
    * @method getExercise
    * @description Obtiene los datos del motor relacionado al ejercicio
    */
    async getMotorData(id) {
      this.loading = true;

      try {
        // Obtengo la configuración
        const response = await this.axios.get('operation/getoperation', {
          params: {
            ejercicios_id: id,
          },
        });

        this.configuration = response.data.config;
        response.data.elements.forEach((element) => {
          this.arrayEleOperation.push({
            POSICION: element.POSICION,
            OPERACION: element.OPERACION,
            RESULTADO: element.RESULTADO,
          });
        });
      } catch (e) {
        this.$toasted.show('Ocurrió un error al leer el ejercicio', { type: 'warning' });
      }

      this.loading = false;
    },
  },
  async mounted() {
    await this.getStrategies();

    // Chequeo si se editando un motor
    if (this.exercise !== null && (this.exercise.ID !== null && this.exercise.ID !== undefined)) {
      await this.getMotorData(this.exercise.ID);
    }

    // Read from storage data
    this.readFromStorage(this.type);
    this.updatedNumOperation();
  },
};
</script>

<style>
.center-text {
  text-align: center;
}
</style>
